import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { api } from './api';

export const CHAVE_EU = ['eu'] as const;

export function useSessao() {
  const q = useQuery({ queryKey: CHAVE_EU, queryFn: () => api.eu(), staleTime: 5 * 60_000, retry: false });
  return { eu: q.data ?? null, carregando: q.isPending, logado: Boolean(q.data) };
}

export function useSair() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.sair(),
    onSuccess: () => { qc.setQueryData(CHAVE_EU, null); },
  });
}

export function RequerSessao({ children }: { children: ReactNode }) {
  const { logado, carregando } = useSessao();
  const location = useLocation();
  if (carregando) return <main className="conteudo entrar"><p className="legenda" role="status">Carregando…</p></main>;
  if (!logado) return <Navigate to={`/entrar?retorno=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return <>{children}</>;
}
